import { inject, Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { LocalStorageService } from './local-storage.service';

export interface User {
  id: number;
  uuid: string;
  nickname: string;
}

@Injectable({
  providedIn: 'root',
})

export class UserService {
  private readonly apiUrl = environment.apiUrl;
  private readonly localStorage = inject(LocalStorageService);
  private http = inject(HttpClient);

  user = signal<User | null>(null);

  async registerUser(nickname: string): Promise<User | void> {
    try {
      const response = await firstValueFrom(
        this.http.post<User>(`${this.apiUrl}/user`, { nickname })
      );
      this.saveUserToLocalStorage(response);
      console.log('User registered:', response.nickname);
      return response;
    } catch (error) {
      console.error('❌ Failed to register user:', error);
    }
  }

  saveUserToLocalStorage(user: User) {
    this.user.set(user);
    this.localStorage.set('uuid', user.uuid);
    console.log('User saved to local storage:', user.nickname);
  }

  async checkClientRegistration() {
    const storedUuid = this.localStorage.get<string>('uuid');
    if (!storedUuid) {
      console.log('No UUID found in local storage. Client is not registered.');
      return;
    }

    try {
      const user = await firstValueFrom(
        this.http.get<User>(`${this.apiUrl}/user/${storedUuid}`)
      );
      this.user.set(user);
      console.log('User found:', user.nickname);
    } catch (error) {
      console.error('❌ Failed to fetch user data:', error);
    }
  }

  getCurrentUser(): string | null {
    return this.user()?.nickname || null;
  }

  getCurrentUserId(): number | null {
    return this.user()?.id || null;
  }

  removeUserData() {
    this.user.set(null);
    this.localStorage.remove('uuid');
    console.log('User cleared from local storage');
  }
}
